export const USER_ACCESS_AREAS = Object.freeze([
  { key: "dashboard", label: "Dashboard", description: "Fleet overview and dashboard summaries" },
  { key: "resources", label: "Resources", description: "Work orders, maintenance, inventory, procurement and SMS resources" },
  { key: "logbooks", label: "Logbooks", description: "Deck, engine, night-order and operational logbooks" },
  { key: "reports", label: "Reports", description: "Voyage, daily, weekly and monthly reports" },
  { key: "marpol", label: "MARPOL", description: "MARPOL electronic record books" },
  { key: "fleet", label: "Fleet & vessels", description: "Fleet map, vessel registry, owners and vessel groups" },
  { key: "performance", label: "Vessel performance", description: "Performance, data quality, alerts and intelligence" },
  { key: "environment", label: "Environment", description: "CII, EEOI and emissions views" },
  { key: "kpi", label: "KPI", description: "KPI dashboards and setup" },
  { key: "safety", label: "Safety & inspections", description: "Near misses and vessel inspections" },
  { key: "people", label: "People & crew", description: "User, crew and profile management" },
  { key: "master-data", label: "Master data", description: "Shared operational reference data" },
  { key: "templates", label: "Template builders", description: "Report, permit and compliance templates" },
  { key: "settings", label: "Settings & access control", description: "Identity, permissions and system configuration" },
  { key: "support", label: "Support", description: "Support tickets" },
  { key: "audit", label: "Activity & IP log", description: "Audit and activity history" },
  { key: "explore", label: "Explore", description: "Available services and module requests" },
]);

export const accessAreaForScreen = (screenKey) => {
  const key = String(screenKey || "");
  if (["superadmin.dashboard", "owner.dashboard", "crew.dashboard"].includes(key)) return "account-shell";
  if (key.startsWith("settings.")) return "settings";
  if (key.startsWith("crew.")) return "people";
  if (key === "vessel.inspections") return "safety";
  if (key.startsWith("vessel.")) return "fleet";
  if (key.startsWith("masterdata.")) return "master-data";
  if (key.startsWith("reports.")) return "reports";
  if (key.startsWith("marpol.")) return "marpol";
  if (key.startsWith("elog.")) return "logbooks";
  if (key.startsWith("templatebuilders.")) return "templates";
  if (key.startsWith("drydock.")) return "resources";
  if (key.startsWith("procurement.")) return "resources";
  if (key === "safety.near-miss") return "safety";
  if (key === "operations.form-builder") return "templates";
  if (["operations.cargo-log", "operations.crew-rest"].includes(key)) return "logbooks";
  if (key.startsWith("operations.")) return "resources";
  return null;
};

const LANDING_PATHS = {
  dashboard: "/",
  resources: "/modules/dashboard/overview",
  logbooks: "/report/engine-log/list",
  reports: "/admin/vessel-reports",
  marpol: "/marpol/oil-record-book-part-1/history",
  fleet: "/fleet-map",
  performance: "/vessel-performance",
  environment: "/environment",
  kpi: "/kpi/dashboard",
  safety: "/safety/near-miss",
  people: "/user/list",
  "master-data": "/master-data",
  templates: "/template-builders",
  settings: "/settings",
  support: "/settings/support/ticket/list",
  audit: "/admin/activity-log",
  explore: "/explore",
};

export const firstAllowedAreaPath = (areas = []) => {
  const allowed = new Set(Array.isArray(areas) ? areas : []);
  const first = USER_ACCESS_AREAS.find(({ key }) => allowed.has(key));
  return first ? LANDING_PATHS[first.key] : "/profile";
};
